import { useGetDemoLinksQuery, useGetDemoQuery } from '@carboncopyco/data';
import { DemoLinkModalBody } from './DemoLinkModalBody';
import { DemoLinkModalProvider } from './DemoLinkModalContext';
import type { DemoLinkModalProps } from './types';

export const DemoLinkModal = (props: DemoLinkModalProps) => {
  const { data: demo } = useGetDemoQuery({
    workspaceId: props.workspaceId,
    organizationId: props.organizationId,
    id: props.assetId,
  });
  const { data: demoLinks, isLoading } = useGetDemoLinksQuery({
    organizationId: props.organizationId,
    assetId: props.assetId,
    assetType: props.assetType,
  });

  const demoLink = demoLinks?.items?.[0];

  if (!demo || isLoading) {
    return null;
  }

  return (
    <DemoLinkModalProvider
      {...props}
      link={demoLink}
      asset={demo}
    >
      <DemoLinkModalBody />
    </DemoLinkModalProvider>
  );
};
